import { useEffect } from 'react';

/**
 * A custom hook that updates the document title
 * @param title - The title to set for the page
 */
export const usePageTitle = (title: string): void => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = `Zakeke - ${title}`;

        // Cleanup function to restore the previous title when component unmounts
        return () => {
            document.title = previousTitle;
        };
    }, [title]);
};
